import { LocaleType } from '../utils/translations_types';
import { baseUrl as apiBaseUrl } from './api';

const config = {
  appName: 'BoltDeliveryProviderPortal',
  version: process.env.REACT_APP_VERSION,
  apiBaseUrl,
  userType: 'provider', // Used in session reducer to generate session ID
  userIdKey: 'provider_id',
  server: {
    scheme: process.env.REACT_APP_API_URL_SCHEME,
    suffix: process.env.REACT_APP_API_URL_SUFFIX,
  },
  bugsnag: {
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  },
  baseUrl: '',

  defaultLocale: LocaleType.English,
  supportedLocales: [
    LocaleType.Azerbaijani,
    LocaleType.Estonian,
    LocaleType.English,
    LocaleType.Croatian,
    LocaleType.Latvian,
    LocaleType.Lithuanian,
    LocaleType.Hungarian,
    LocaleType.Polish,
    LocaleType.Portuguese,
    LocaleType.Romanian,
    LocaleType.Slovakian,
    LocaleType.Swedish,
    LocaleType.Czech,
    LocaleType.Russian,
    LocaleType.Ukrainian,
    LocaleType.Georgian,
    LocaleType.Greek,
  ],

  sessionIdValidityMilliseconds: 30 * 60 * 1000,

  // Interval between successful polling requests
  // (from completion of previous request to starting of next one)
  pollingInterval: 2 * 1000,

  // min & max boundaries for polling timeout.
  // We start with min value and increase it up to max value if needed.
  // NB! These two must be set to power of 2 seconds.
  minPollingTimeout: 2 * 1000,
  maxPollingTimeout: 64 * 1000,

  // How many requests must be more than 4x faster than the current timeout
  // before we reduce the timeout value to half.
  fastPollingRequestCountToDecreaseTimeout: 2,

  // The same as default
  accessTokenBlockingTimeoutBeforeExpiryInSeconds: 10,

  // This defaults to 5 minutes, however the access token expiry time for courier is also 5 minutes,
  // which would result in us refreshing the access token after every few requests.
  // So for now, setting this to 1 minute, a longer than the above, but much less then 5 minutes.
  accessTokenRefreshTimeoutBeforeExpiryInSeconds: 60,

  guidelineSources: {
    baseUrl: process.env.REACT_APP_GUIDELINE_SOURCE_BASE_URL,
  },

  appVersionStateCheckInterval: 4 * 60 * 60 * 1000,
  translationApiClientHost: 'https://translation.taxify.eu',
  crowdInProject: 'fd-clients',
  crowdInBaseTranslationsFolderName: 'Delivery Provider Portal',
  featureFlags: {
    useNewPromotionsDesign: process.env.REACT_APP_FEATURE_FLAG_USE_NEW_PROMOTIONS_DESIGN === '1',
  },
};

export type ConfigType = typeof config;
export default config;
